module.exports = __webpack_public_path__ + "static/media/filter-loading.0404695a.svg";